import axios from 'axios'
import qs from 'qs'
import router from '@/router/routers'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { setCookie, getCookie } from '@/utils/cookie'
import Config from '@/utils/globalSettings.js'
import { baseURL } from '@config/index.js'
if (process.env.NODE_ENV === 'production') {
  console.log('window', window, window.g)
  if (window.g) {
    setCookie('baseUrl', window.g.Manage_API_BASE_URL)
  }
  if (process.env.ENV_CONFIG === 'sit') {
    setCookie('baseUrl', baseURL)
  }
}

var baseUrl = getCookie('baseUrl')
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : '/', // api 的 base_url
  // baseURL: process.env.BASE_API, // api 的 base_url
  baseURL: process.env.NODE_ENV === 'production' ? baseUrl : process.env.BASE_API, // api 的 base_url
  timeout: Config.timeout, // 请求超时时间
  withCredentials: true,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers['X_Auth_Token'] = getToken() ? getToken() : '' // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['Content-Type'] = 'application/json'
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    // console.log('request拦截器 config:', config)
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  },
)

// response 拦截器
service.interceptors.response.use(
  (response) => {
    // console.log('response 拦截器:', response)
    const code = Number(response.status)
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message,
      })
      return Promise.reject(new Error('error'))
    } else {
      const rcode = Number(response.data.status)
      // const requestUrl = response.config.url
      // console.log('rcode', rcode)
      if (rcode === 401) {
        console.log('执行')
        MessageBox.confirm(response.data.msg, '系统提示', {
          confirmButtonText: '重新登录',
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning',
        }).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        return false
      }
      return response.data
    }
  },
  (error) => {
    let code = 0
    try {
      console.log('返回error:', error)
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 2500,
        })
        return Promise.reject(error)
      }
      if (error.toString().indexOf('Error: Network Error') !== -1) {
        Notification.error({
          title: '网络请求错误',
          duration: 2500,
        })
        return Promise.reject(error)
      }
    }
    if (code === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else if (code === 403) {
      router.push({ path: '/401' })
    } else {
      Notification.error({
        title: error,
        duration: 3000,
      })
    }
    return Promise.reject(error)
  },
)

export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        // console.log('err', err)
        reject(err.data)
      })
  })
}

// 封装post请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export { service }



// WEBPACK FOOTER //
// ./src/utils/request.js